import { notionStore } from '@stores/notion.store';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import React from 'react';

import { Icon } from '../Icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';

import styles from './LabelWithTooltip.module.scss';

interface LabelWithTooltipProps {
  name: string;
  description?: string;
  tooltipClassName?: string;
  className?: string;
}

export const LabelWithTooltip: React.FC<LabelWithTooltipProps> = observer(
  ({ name, className, tooltipClassName, description }) => {
    const { values } = notionStore;

    return (
      <div className={styles.labelContainer}>
        <div className={clsx(styles.label, className)}>{name}</div>
        <Tooltip
          className={styles.tooltip}
          tooltipClassName={tooltipClassName}
          content={values ? <div dangerouslySetInnerHTML={{ __html: description || values[name] }} /> : null}
          placement="right"
          isFixed
          hideArrow
        >
          <Icon
            className={styles.infoIcon}
            name="info"
          />
        </Tooltip>
      </div>
    );
  },
);
